import { render, staticRenderFns } from "./DeductStatisManage.vue?vue&type=template&id=2f9ce3a1&"
import script from "./DeductStatisManage.vue?vue&type=script&lang=js&"
export * from "./DeductStatisManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports